import React from "react";
import styled from "styled-components";

import { useIntl } from "../../../../../../shared/core/i18n/use-intl";
import { CARD_CREATION_MODAL_ID } from "../../../../../core/modal/modal-id";
import { BluePrimaryButton } from "../../../../common/buttons/primary-button";
import { Modal } from "../../../../common/modal/modal";
import { PlusIcon } from "../../../../common/svg/plus-icon";
import { StaticAssets } from "../../../../styles/custom-assets";
import { theme } from "../../../../styles/theme";
import { CardCreationModal } from "./create-card-view";

/** What the "Ma carte" screen shows to a holder who owns no card yet. */
export const EmptyCardPanel = () => {
  const { formatMessage } = useIntl();

  const startCardCreationFlow = () => {
    Modal.present(CARD_CREATION_MODAL_ID, () => <CardCreationModal />, {
      canBeDismissed: false,
    });
  };

  return (
    <Container>
      <Panel>
        <Illustration src={StaticAssets.cardNew} alt="" />
        <Title>{formatMessage("cardsList.emptyTitle")}</Title>
        <Description>{formatMessage("cardsList.emptyDescription")}</Description>
      </Panel>
      <AddCardButton size="XS" onClick={startCardCreationFlow}>
        <PlusSign width={20} height={20} />
        {formatMessage("cardsList.addCardButton")}
      </AddCardButton>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  width: 100%;
`;

const Panel = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  min-height: 520px;
  padding: 32px 24px;
  border-radius: 12px;
  background-color: ${theme.colors.blue[200]};
`;

const Illustration = styled.img`
  width: 67px;
  height: 68px;
`;

const Title = styled.span`
  ${theme.mediumText};
  margin-top: 16px;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  color: #741537;
`;

const Description = styled.span`
  ${theme.text};
  margin-top: 8px;
  text-align: center;
  font-size: 13px;
  line-height: 18px;
  color: #8c8c8c;
`;

const AddCardButton = styled(BluePrimaryButton)`
  margin-top: 28px;
  padding: 13px 28px;
  box-shadow: none;

  /* DefaultButton wraps the children, so the gap belongs to that wrapper. */
  > div {
    gap: 8px;
  }
`;

/* The icon paints itself black, so the fill is set back here rather than through a prop. */
const PlusSign = styled(PlusIcon)`
  flex-shrink: 0;

  path {
    fill: #ffffff;
  }
`;
